// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"b7733aa1","455":"3ac58718"}[chunkId] + ".chunk.js";
};